export default "__VITE_ASSET__DRod3stw__"